<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">{{ $t('components.addBrand') }}</strong>
                <strong v-else>{{ $t('buttons.editBrand') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

                <strong v-if="status_form!=0">{{edit_name}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>

                <a :href="$route.fullPath" target="_blank">
                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="dark"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>
              </CCol>
            </CRow>
          </CCardHeader>
          <CRow>

            <CCol col="12">
              <CCardBody>
                <CRow>
                  <CCol col="3">
                    <CInput
                        :label="$t('components.brandName')"

                        v-model="name"
                        autocomplete="name"
                    />
                  </CCol>


<!--                  <CCol col="2">-->
<!--                    <CInput-->
<!--                        :label="$t('components.color')"-->
<!--                        type="color"-->
<!--                        v-model="color"-->


<!--                    />-->
<!--                  </CCol>-->
                  <CCol col="3">
                    <CTextarea
                        :label="$t('components.summary')"

                        v-model="description"

                        rows="4"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInputFile
                        :label="$t('components.image')"

                        custom
                        ref="file_selector"
                        v-show="false"

                        v-on:change="handleFileUpload"
                    />
                    <CCol col="12" class="text-center" v-on:click="open_file_selector()"
                    >
                      <CImg height="120px"
                            width="120px"
                            v-model="previewImage"
                            v-if="previewImage" :src="previewImage"
                      />
                    </CCol>
                  </CCol>

                </CRow>
                <CRow>


                </CRow>
              </CCardBody>

            </CCol>
            <CCol col="12">
              <CRow v-show="this.$route.path == '/dashboard/base/inventory-settings'">
                <CCol md="6">
                  <CCard>
                    <CCardHeader>
                      <strong>{{ $t('components.listBrands') }}</strong>
                    </CCardHeader>
                    <CCardBody>
                      <CDataTable
                          :items="items"
                          :fields="fields"
                          @row-clicked="table_row_clicked"

                          :items-per-page="10"
                          hover
                          sorter
                          striped
                          border
                          column-filter
                          pagination
                      >
                        <template #row="{item}">

                          <td style="text-align: center">
                            <p >{{ item.row_id + 1 }}</p>

                          </td>

                        </template>
                        <template #name="{item}">

                          <td>
                            <p >{{ item.brandName }}</p>

                          </td>

                        </template>

                        <template #summary="{item}">

                          <td>
                            <p  v-if="item.summary!= 'undefined'">{{ item.summary }}</p>
                            <p  v-else></p>

                          </td>

                        </template>

                        <template #color="{item}">

                          <td>
                            <div :style="get_style(item.color)" :color="item.color">
                              {{ item.color }}
                            </div>
                          </td>

                        </template>

                        <template #image="{item}">


                          <td>
                            <CImg width="50px" height="50px" v-bind:src="$root.base_url+'/'+item.imageName"/>
                          </td>

                        </template>

                        <template #operation="{item}">
                          <td>
<!--                            <CIcon @click.native="goSubCategories(item)" class="mr-1 text-success"-->
<!--                                   name="cilApplications"/>-->

<!--                            <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>-->

                            <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                          </td>
                        </template>


                      </CDataTable>
                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                  </CCard>
                </CCol>
              </CRow>

            </CCol>

          </CRow>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm_brand" + new Date().getTime() + "_" + this.$vnode.tag,
      edit_name:'',
      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '/img/placeholder.png',
      description: '',
      items: [],
      table_clicks:0,
      table_clicks_timer:null,
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'brandName', label: this.$t('tables.name'), _style: 'width:20%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:20%'},
        // {key: 'color', label: this.$t('tables.color'), _style: 'width:10%;'},
        {key: 'image', label: this.$t('tables.image'), _style: 'width:20%;'},
        {key: 'operation', label: "", filter: false, _style: 'width:10%;'},
      ],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }

    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' ) {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        backgroundColor: color

      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.edit_name = item.brandName;
      this.name = item.brandName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = this.$root.base_url+'/'+item.imageName;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBrands', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: "/dashboard/products/list-brand/" + item.id})
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddBrand";
      } else {
        url = "EditBrand";
        formData.append('id', this.status_form)
      }

      formData.append('File', this.file);
      formData.append('brandName', this.name);
      formData.append('Color', this.color);
      formData.append('Summary', this.description);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.name = '';
        self.color = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);
        bus.$emit('close_add_base_modal', 'false');

      })
          .catch(function (error) {
            console.log(error);
          });

    }, delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBrand";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
